export default __webpack_public_path__ + "static/media/404.00cee8ed.svg";